import React, { useState } from "react";
import Modules from "./Modules";
import Block from "./Block";
import Select from "react-select";
import Graph from "./Graph";
import GraphMultiSeries from "./GraphMultiSeries";
import GraphAnalysis from "./GraphAnalysis";
import PropTypes from "prop-types";
import GraphRaw from "./GraphRaw";
import GraphNav from "./GraphNav";
import GraphDucky from "./GraphDucky";
import GraphHorizontal from "./GraphHorizontal";

const Section = ({ modules, title, index, sectionId, regionAnalysisIds }) => {
  const [activeModule, setActiveModule] = useState(0);
  const [selectedVariant, setSelectedVariant] = useState(0);

  const [tableId, setTableId] = useState(null);
  const [source, setSource] = useState("SpareBank 1 Sør-Norge");
  const [updated, setUpdated] = useState(
    new Date().toLocaleString("nb-NO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }) + ""
  );

  if (!modules) {
    return null;
  }
  if (!modules[activeModule]) {
    return null;
  }

  const GraphType = (type) => {
    if (type.type === "multi-series") {
      return (
        <GraphMultiSeries
          gid={`graph-multi-series-key-${index}-${activeModule}-${selectedVariant}`}
          key={`graph-multi-series-component-${index}-${activeModule}-${selectedVariant}`}
          module={modules[activeModule].variations[selectedVariant]}
          setTableId={setTableId}
          setUpdated={setUpdated}
        />
      );
    }
    if (type.type === "raw-data") {
      return (
        <GraphRaw
          gid={`graph-multi-series-key-${index}-${activeModule}-${selectedVariant}`}
          key={`graph-multi-series-component-${index}-${activeModule}-${selectedVariant}`}
          module={modules[activeModule].variations[selectedVariant]}
          setTableId={setTableId}
          setUpdated={setUpdated}
        />
      );
    }
    if (type.type === "bar-horizontal") {
      return (
        <GraphHorizontal
          gid={`graph-multi-series-key-${index}-${activeModule}-${selectedVariant}`}
          key={`graph-multi-series-component-${index}-${activeModule}-${selectedVariant}`}
          module={modules[activeModule].variations[selectedVariant]}
          setTableId={setTableId}
          setUpdated={setUpdated}
        />
      );
    }

    return (
      <Graph
        gid={`graph-key-${index}-${activeModule}-${selectedVariant}`}
        key={`graph-component-${index}-${activeModule}-${selectedVariant}`}
        module={modules[activeModule].variations[selectedVariant]}
        setTableId={setTableId}
        setUpdated={setUpdated}
      />
    );
  };
  if (modules[activeModule].type && modules[activeModule].type === "regionalanalyse") {
    return (
      <React.Fragment>
        <h3 className="chart-title sb1-mb-2">{title}</h3>
        <Modules
          modules={modules}
          activeModule={activeModule}
          setActiveModule={(id) => {
            setActiveModule(id);
            setSelectedVariant(0);
          }}
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <GraphAnalysis
                module={modules[activeModule]}
                sectionId={sectionId}
                setUpdated={setUpdated}
                setSource={setSource}
                regionIds={regionAnalysisIds}
              />
            </div>
            <div className="col-lg-4">
              <div className="spacer" />
              <Block>
                <h2>{modules[activeModule].title}</h2>
                <p>{modules[activeModule].description}</p>
                <hr />
                <div style={{ fontSize: "0.5rem" }}>Kilde: {source}</div>
              </Block>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
  if (modules[activeModule].type && modules[activeModule].type === "Nav") {
    return (
      <React.Fragment>
        <h3 className="chart-title sb1-mb-2">{title}</h3>
        <Modules
          modules={modules}
          activeModule={activeModule}
          setActiveModule={(id) => {
            setActiveModule(id);
            setSelectedVariant(0);
          }}
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <GraphNav
                module={modules[activeModule]}
                sectionId={sectionId}
                setUpdated={setUpdated}
                setSource={setSource}
              />
            </div>
            <div className="col-lg-4">
              <div className="spacer" />
              <Block>
                <h2>{modules[activeModule].title}</h2>
                <p>{modules[activeModule].description}</p>
                <hr />
                <div style={{ fontSize: "0.5rem" }}>Kilde: {source}</div>
              </Block>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
  if (modules[activeModule].type && modules[activeModule].type === "ducky") {
    return (
      <React.Fragment>
        <h3 className="chart-title sb1-mb-2">{title}</h3>
        <Modules
          modules={modules}
          activeModule={activeModule}
          setActiveModule={(id) => {
            setActiveModule(id);
            setSelectedVariant(0);
          }}
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <GraphDucky
                module={modules[activeModule]}
                sectionId={sectionId}
                setUpdated={setUpdated}
                setSource={setSource}
              />
            </div>
            <div className="col-lg-4">
              <div className="spacer" />
              <Block>
                <h2>{modules[activeModule].title}</h2>
                <p>{modules[activeModule].description}</p>
                <hr />
                <div style={{ fontSize: "0.5rem" }}>Kilde: {source}</div>
              </Block>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
  if (!modules[activeModule].variations || modules[activeModule].variations.length === 0) {
    return null;
  }
  return (
    <React.Fragment>
      <h3 className="chart-title sb1-mb-2">{title}</h3>
      <Modules
        modules={modules}
        activeModule={activeModule}
        setActiveModule={(id) => {
          setActiveModule(id);
          setSelectedVariant(0);
        }}
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <Block>
              {modules[activeModule].variations.length > 1 && (
                <Select
                  options={parseOptions(modules[activeModule].variations)}
                  defaultValue={parseOptions(modules[activeModule].variations)[0]}
                  onChange={(d) => {
                    setSelectedVariant(d.value);
                  }}
                  value={parseOptions(modules[activeModule].variations)[selectedVariant]}
                />
              )}
              <GraphType type={modules[activeModule].variations[selectedVariant].type} />
            </Block>
          </div>
          <div className="col-lg-4">
            <div className="spacer" />
            <Block>
              <h2>{modules[activeModule].variations[selectedVariant].title}</h2>
              <p>{modules[activeModule].variations[selectedVariant].description}</p>
              <hr />
              <div style={{ fontSize: "0.5rem" }}>
                Kilde: {tableId ? `SSB tabell ${tableId}` : `SpareBank 1 Sør-Norge`}
              </div>
            </Block>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Section;

Section.propTypes = {
  title: PropTypes.string.isRequired,
  modules: PropTypes.array.isRequired,
};

const parseOptions = (options) => {
  return options.map((option, i) => Object.assign({}, { label: option.name, value: i }));
};
